import { Avatar, MyAvatar } from 'components/avatar/Avatar'
import { SBoundAvatarsContainer, SContentContainer } from './ContactNotificationModal.styled'
import { ActualContact } from 'components/contact/contactUtils'
import { Icon } from 'components/icon'
import { Text, Title } from 'components/Typography'
import { ReactNode, VFC } from 'react'
import { colors } from 'utils/colors'

export type ContactModalContentProps = {
  actualContact?: ActualContact
  topTitleText?: ReactNode
  titleText: ReactNode
  descriptionText: ReactNode
}

export const ContactModalContent: VFC<ContactModalContentProps> = (props) => {
  const { actualContact, titleText, descriptionText, topTitleText } = props
  const isLegacy = actualContact?.user?.type === 'LEGACY_CONTACT'

  return (
    <SContentContainer>
      {topTitleText && <Text variant="bodyBold">{topTitleText}</Text>}
      <SBoundAvatarsContainer css={{ marginTop: '2.5rem' }}>
        <MyAvatar size={120} />
        <Avatar owner={actualContact} size={120} />
        <Icon name={isLegacy ? 'ShieldCheck' : 'Check'} color={colors.green[200]} />
      </SBoundAvatarsContainer>
      <Title variant="h7">{titleText}</Title>
      <Text>{descriptionText}</Text>
    </SContentContainer>
  )
}
